import script from "./FormValidationMixin.vue?vue&type=script&lang=js"
export * from "./FormValidationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__